export enum LegalEntityType {
  Charity = 'charity',
  C_Corporation = 'c-corporation',
  ExtraGovernmentalBody = 'extra-governmental-body',
  LimitedLiabilityCompany = 'limited-liability-company',
  LimitedLiabilityPartnership = 'limited-liability-partnership',
  LimitedPartnership = 'limited-partnership',
  GeneralPartnership = 'general-partnership',
  PensionFund = 'pension-fund',
  S_Corporation = 's-corporation',
  StateOwnedEnterprise = 'state-owned-enterprise',
  Trust = 'trust',
  Other = 'other',
}
